import {
  coreExtensionData,
  createExtension,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import { CookieAuthRefreshProvider } from '@backstage/plugin-auth-react';
import { queryClient } from '@ipen-portal/plugin-trpc-react';
import { Layout } from '@ipen/components';
import { QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

export const LayoutExtension = createExtension({
  attachTo: {
    id: 'app/root',
    input: 'children',
  },

  factory: ({ inputs }) => [
    coreExtensionData.reactElement(
      <CookieAuthRefreshProvider pluginId="app">
        <NuqsAdapter>
          <QueryClientProvider client={queryClient}>
            <Layout
              content={inputs.content.get(coreExtensionData.reactElement)}
              nav={inputs.nav.get(coreExtensionData.reactElement)}
            />
          </QueryClientProvider>
        </NuqsAdapter>
      </CookieAuthRefreshProvider>,
    ),
  ],

  inputs: {
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
    nav: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
  },

  name: 'layout',

  output: [coreExtensionData.reactElement],
});
